import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Popover, Svg, Text } from '@hopskipdrive/react-components';
import { ArrowDropDown } from '@mui/icons-material';

import { getSubClassifications } from '../../../api/services/Incidents';
import IncidentSubClassificationDropdown from '../../../components/IncidentSubClassificationDropdown';
import { IncidentSubclassification } from '../../../types/incidents';
import { CloseButton, FilterButton, FilterTypeContainer } from '../FilterPanel.styles';

import { CustomPopper } from './SubclassificationFilter.styles';

export const SubclassificationFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState<IncidentSubclassification | null>(null);
  const isActive = Object.fromEntries(searchParams.entries()).subclassification;

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onChange = (subclassification) => {
    const newParams = new URLSearchParams(searchParams);

    newParams.delete('subclassification');
    newParams.delete('subclassificationLabel');

    if (subclassification) {
      newParams.set('subclassification', encodeURIComponent(subclassification.id));
      newParams.set('subclassificationLabel', encodeURIComponent(subclassification.name));
    }

    setValue(subclassification);
    setSearchParams(newParams);
    handleClose();
  };

  const initialize = async () => {
    const subclassificationId = searchParams.get('subclassification');

    if (subclassificationId) {
      const result = await getSubClassifications({ id: subclassificationId });

      if (result.data.length > 0) {
        setValue(result.data[0]);
      }
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const id = open ? 'subclassification-filter-popover' : undefined;

  return (
    <>
      <FilterButton variant="text" open={open} active={Boolean(isActive)} onClick={handleOpen}>
        Subclassification <ArrowDropDown />
      </FilterButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ '.MuiBackdrop-root': { backgroundColor: 'transparent' } }}
      >
        <FilterTypeContainer sx={{ width: '30rem' }}>
          <Box className="filter-header">
            <Text variant="body2">Filter by Subclassification</Text>
            <CloseButton onClick={handleClose}>
              <Svg icon="cross" />
            </CloseButton>
          </Box>
          <IncidentSubClassificationDropdown
            open={true}
            value={isActive ? value : null}
            onChange={onChange}
            popper={CustomPopper}
          />
        </FilterTypeContainer>
      </Popover>
    </>
  );
};
